
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/chat.vue';
    import movil from './movil/chat.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {



    }
